import React, { FC, useEffect, useState } from 'react'
import { Modal } from '../product-modal'

export type Author = {
  author?: string
}

export type Inspiration = {
  inspiration?: Author
}

export type ProductHit = {
  id: string
  product_image?: string
  title?: string
  body_html_safe?: string
  meta?: Inspiration
}

export type Props = {
  product: ProductHit
  all_items_no: number
  no: number
  goToPrev: (val: number) => void
  goToNext: (val: number) => void
  is_active: number
  deactivate: () => void
}

export const Card: FC<Props> = ({
  product,
  all_items_no,
  no,
  goToPrev,
  goToNext,
  is_active,
  deactivate
}) => {
  const [modalState, setmodalState] = useState<boolean>(false)

  useEffect(() => {
    is_active === no ? setmodalState(true) : setmodalState(false)
  }, [is_active, no])

  function openModal() {
    setmodalState(true)
  }

  function closeModalProduct() {
    setmodalState(false)
    deactivate()
  }

  function goToPrevCard(e: number) {
    goToPrev(e)
  }

  function goToNextCard(e: number) {
    goToNext(e)
  }

  return (
    <div>
      <Modal
        product={product}
        state={modalState}
        all_items_no={all_items_no}
        no={no}
        closeModal={closeModalProduct}
        goToPrevCard={goToPrevCard}
        goToNextCard={goToNextCard}
      />

      <div className="ProductCard" onClick={openModal}>
      <img
        src={product.product_image}
        alt="Product Image"
        className="ProductCard-image additional-placeholder"
        loading="lazy"
        />

        {product.title && (
          <div className="ProductCard-title">{product.title}</div>
        )}

        {product.body_html_safe && (
          <div className="ProductCard-desc">{product.body_html_safe}</div>
        )}

        {product.meta &&
          product.meta.inspiration &&
          product.meta.inspiration.author && (
            <div className="ProductCard-author">
              {product.meta.inspiration.author}
            </div>
          )}
      </div>
    </div>
  )
}
